import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { UsuarioService } from 'src/app/core/services/usuario.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SimpleModalComponent } from 'src/app/shared/modals/simple-modal/simple-modal.component';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { IdiomaService } from 'src/app/core/services/idioma.service';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-esqueceu-senha',
  templateUrl: './esqueceu-senha.component.html',
  styleUrls: ['./esqueceu-senha.component.scss']
})

export class EsqueceuSenhaComponent implements OnInit {
  formGroup: FormGroup;
  data: any;

  idiomaSelecionado;
  idiomas;

  constructor(
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    private usuarioService: UsuarioService,
    private modalService: NgbModal,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private idiomaService: IdiomaService,
    private gaService: GoogleAnalyticsService
  ) {
    this.carregarFormGroup();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
      this.idiomaSelecionado = this.idiomaService.getIdioma();
    });
  }

  ngOnInit() {
    this.carregarDados();

    this.idiomaSelecionado = this.idiomaService.getIdioma();
    this.idiomas = this.idiomaService.getIdiomas();
  }

  carregarFormGroup() {
    this.formGroup = this.formBuilder.group(
      {
        formNomeEmpresa: new FormControl('', Validators.required),
        formUsuario: new FormControl('', Validators.required),
        formEmail: new FormControl('', Validators.compose(
          [
            Validators.required,
            Validators.email
          ]
        ))
      }
    );
  }

  carregarDados() {
    this.translate.get('ESQUECEU_SENHA').subscribe(res => {
      this.data = res;
      this.titleService.setTitle(this.data.HEADER_TITLE);
      this.meta.updateTag({name: 'description', content: this.data.META_DESCRIPTION});
      this.meta.updateTag({name: 'keywords', content:  this.data.META_KEYWORDS});
      this.gaService.pageView(this.router.url);
    });
  }

  onSubmit() {
    const nomeEmpresa = this.formGroup.get('formNomeEmpresa').value;
    const usuario = this.formGroup.get('formUsuario').value;
    const email = this.formGroup.get('formEmail').value;

    this.usuarioService.recuperarSenha(
      nomeEmpresa,
      usuario,
      email
    )
      .subscribe(
        res => {
          if (res != null) {
            const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
            modalRef.componentInstance.message = this.data.MENSAGEM_SUCESSO;
          }
          this.formGroup.reset();
        },
        err => {
          if (err != null) {
            if (err.error.text != null) {
              const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
              modalRef.componentInstance.message = this.data.MENSAGEM_SUCESSO;
            } else if (err.error != null) {
              const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
              modalRef.componentInstance.message = this.data.MENSAGEM_ERRO;
            }
          }
          this.formGroup.reset();
        }
      );
  }

  alterarIdioma(idioma: string) {
    this.translate.use(idioma);
  }

}
